import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ContentCodeStore {

}

export enum ContentCodeStoreKeys {

}
